export interface AuthInputInterface {
  name: string;
  placeholder: string;
  type: string;
  required: boolean;
  minlength: number;
  errorMessage: string;
  validationExp: any;
}
